<template>
  <vx-card :id="`question-card_${question.assessment.questionId}`" v-show="isCardActiveLocal" :style="{ 'background-color': question.status == 'correct' && quizType == 'graded' ? 'rgba(107, 255, 81, 0.3)' : question.status == 'answered' || quizType == 'survey' ? 'none' : 'rgba(255, 56, 56, 0.3)' }">
    <div class="vx-row">
      <div v-if="quizType == 'graded'" class="vx-col w-full">
        <p class="mb-2">{{ question.questionText }}</p>
        <p :style="{'color': setColor(question) }">Answer: {{ question.answer }}</p>
        <div class="mt-2" v-if="question.acceptableAnswers.length != 0">
          <p>Acceptable Answers: </p>
          <div class="vx-row">
            <div class="vx-col" v-for="(answer, index) in question.acceptableAnswers" :key="index">
              <p style="font-weight: 700">{{ answer }}</p>
            </div>
          </div>
        </div>
        <div class="mt-2 vx-row">
          <vs-spacer></vs-spacer>
          <div class="vx-col">
            <p><small>Max Attempts: {{ question.maxAttempts }}</small></p>
            <p><small>Used Attempts: {{ question.usedAttempts }}</small></p>
          </div>
        </div>
      </div>
      <div v-else class="vx-col w-full">
        <p class="mb-2">{{ question.questionText }}</p>
        <p>Answer: {{ question.answer }}</p>
        <div class="mt-2" v-if="question.acceptableAnswers.length != 0">
          <p>Acceptable Answers: </p>
          <div class="vx-row">
            <div class="vx-col" v-for="(answer, index) in question.acceptableAnswers" :key="index">
              <p style="font-weight: 700">{{ answer }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <comment-view :isCardActive="commentView" :question="question" :quizType="quizType" :predefinedComments="predefinedComments"/>
  </vx-card>
</template>

<script>
  import commentView from './iSpringCommentView.vue';
  export default {
    components: {
      commentView
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      question: {
        type: Object,
        required: false
      },
      questionCardTitle: {
        type: String,
        required: false
      },
      predefinedComments: {
        type:Array,
        required: false
      },
      quizType: {
        type: String,
        required: false
      }
    },
    data() {
      return {
        commentView: true
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          if(self.question){

          }else{
            self.initValues();
          }
        }
      },
      question: function(val) {
        if(val){
          this.commentView = true;
        }
      }
    },
    methods: {
      setColor(question) {
        if(question.acceptableAnswers.length != 0){
          if(question.acceptableAnswers.includes(question.answer)){
            return '#28c76f';
          }
          else {
            return '#ea5455';
          }
        }
        else{
          if(question.status == "correct"){
            return '#28c76f';
          }
          else{
            return '#ea5455';
          }
        }
      },
      saveData() {
        this.initValues();
        this.$emit('saveData');
      },
      initValues() {
        
        this.errors.clear();
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      scrollToFooter() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("footerGlobal"), 100, scrollOptions);
      },
    }
  }

</script>

<style lang="scss">

</style>
